import { IUpdateBidInput } from 'types/graphqlTypes'
import { TCarrierOptionSchema } from '../schema/CarrierOptionSchema'

interface IGetUpdateBidInputProps {
  carrierOptionId: string
  formData: TCarrierOptionSchema
  shipmentId: string
}

export const getUpdateBidInput = ({
  carrierOptionId,
  formData,
  shipmentId,
}: IGetUpdateBidInputProps): IUpdateBidInput => {
  const {
    amount,
    carrierContactName,
    carrierContactPhone,
    carrierContactPhoneExt,
    carrierContactUserId,
    counterOfferAmount,
    note,
  } = formData || {}
  return {
    id: carrierOptionId,
    bid: {
      amount: amount || 0,
      carrierContactName,
      carrierContactPhone,
      carrierContactPhoneExt,
      carrierContactUserId,
      note,
      shipmentId,
      counterBidAmount: counterOfferAmount,
      removeCounterBid: !counterOfferAmount,
    },
  }
}
